/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object,
    shape,
    arrayOf,
    string,
    number,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';

import customBreakpoints from '../../../../helpers/customBreakpoints';
import GraphqlSimpleSearchElement from './GraphqlSimpleSearchElement';

const styles = (theme) => ({
    root: {
        margin: '32px 0',
        [theme.breakpoints.down(600)]: {
            margin: '16px 0',
            '& h1': {
                fontSize: 18,
            },
        },
    },
    header: {
        marginBottom: 16,
        textAlign: 'center',
        '& h1': {
            fontSize: 24,
        },
        [theme.breakpoints.down(600)]: {
            marginBottom: 16,
            '& h1': {
                fontSize: 18,
            },
        },
    },
    simple4Row: {
        flex: '0 0 25%',
        marginBottom: '16px',
        maxWidth: '25%',
        position: 'relative',
        width: '100%',
        paddingRight: '8px',
        paddingLeft: '8px',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            flex: '0 0 50%',
            maxWidth: '50%',
        },
    },
    seeMore: {
        margin: '0px 8px 16px',
        textAlign: 'right',
        fontSize: 14,
        textDecoration: 'underline',
    },
});

const GraphqlSearchArticles = ({
    classes, articleData, searchTerm,
}) => {
    const seed = useUIDSeed();
    return (
        <Grid item>
            <div className={classes.header}>
                <h1>Discover Related Articles</h1>
            </div>
            <Grid container justifyContent="center">
                {articleData?.blogs?.map((blog) => (
                    <Grid
                        item
                        className={classes.simple4Row}
                        key={seed(blog)}
                        data-testid="search-article-component"
                    >
                        <GraphqlSimpleSearchElement
                            title={blog?.title}
                            image={blog?.image}
                            description={blog?.excerpt}
                            redirectUrl={`/articles${blog?.url}`}
                            elementType="article"
                        />
                    </Grid>
                ))}
            </Grid>
            <div className={classes.seeMore}>
                <Link target="_blank" to={`/articles/search/${searchTerm}`}>See More Related Articles</Link>
            </div>
        </Grid>
    );
};

GraphqlSearchArticles.propTypes = {
    classes: object.isRequired,
    articleData: shape({
        blogs: arrayOf(shape({
            uid: string,
            title: string,
            excerpt: string,
            image: string,
            contentType: string,
            dateModified: string,
            datePublished: string,
            url: string,
        })),
        total: number,
        pages: number,
    }),
    searchTerm: string.isRequired,
};

GraphqlSearchArticles.defaultProps = {
    articleData: {},
};

const enhance = compose(
    withStyles(styles),
);

export default enhance(GraphqlSearchArticles);
